module.exports = __webpack_public_path__ + "img/IMG_9786_L_WoodMatted.216d6005.jpg";